export enum UserHandState {
    Raised = "raised",
    Lowered = "lowered"
}
